import { ChangeDetectionStrategy, Component, inject, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { EpErrorService, ToastService } from '@isophi/core-ui';
import { DayOffsService, KindergartenDayOffWrite } from '@isophi/mng-api';
import { TranslocoService } from '@jsverse/transloco';
import { compareDesc } from 'date-fns';
import { NgxSpinnerService } from 'ngx-spinner';
import { finalize } from 'rxjs';

import { RouterLinkFactory } from '../../../../core/router/router-link.factory';
import { HelperService } from '../../../../core/services/helper.service';
import { HolidaysDatesFormComponent } from '../../components/holidays-dates-form/holidays-dates-form.component';

@Component({
  selector: 'app-create-holidays-dates',
  templateUrl: './create-holidays-dates.component.html',
  styleUrls: ['./create-holidays-dates.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CreateHolidaysDatesComponent {
  private readonly epErrorService = inject(EpErrorService);
  @ViewChild(HolidaysDatesFormComponent) holidaysDatesFormComponent: HolidaysDatesFormComponent;

  constructor(
    private helperService: HelperService,
    public links: RouterLinkFactory,
    private translocoService: TranslocoService,
    private dayOffsService: DayOffsService,
    private spinner: NgxSpinnerService,
    private toastr: ToastService,
    private router: Router
  ) {
    this.helperService.setTitle(null, this.translocoService.translate('settings/addDaysOff'));
  }

  createDaysOff(holidaysDatesForm: KindergartenDayOffWrite): void {
    if (holidaysDatesForm.dateTo && compareDesc(holidaysDatesForm.date, holidaysDatesForm.dateTo) === -1) {
      this.toastr.error(this.translocoService.translate('evidence/dateError'));
    } else {
      this.spinner.show();

      this.dayOffsService
        .dayOffsCreate(holidaysDatesForm)
        .pipe(finalize(() => this.spinner.hide()))
        .subscribe({
          next: () => {
            this.toastr.success(
              this.translocoService.translate('settings/addDaysOffSuccess'),
              this.translocoService.translate('settings/addDaysOff')
            );
            this.holidaysDatesFormComponent.resetGroupForm();
            this.router.navigate(this.links.holidaysDates());
          },
          error: (e) => {
            this.epErrorService.handleEpErrorResponse(e, { defaultMessage: this.translocoService.translate('settings/addDaysOffFailed') });
          },
        });
    }
  }
}
